"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _debugLogger = _interopRequireDefault(require("../utils/debugLogger"));

var settingsCache;

var settingsResolver = function settingsResolver(settings) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (settings.autoDiscover) {
    if (settingsCache && useCache) {
      (0, _debugLogger.default)('returning resolved settings from cache', settings.debug);
      return Promise.resolve(settingsCache);
    }

    (0, _debugLogger.default)('querying metadata for endpoints', settings.debug);
    var authority = settings.authority,
        debug = settings.debug;
    return fetch("".concat(authority, "/.well-known/openid-configuration"), {
      mode: 'cors'
    }).then(function (data) {
      if (!data.ok) {
        throw new Error();
      }

      return data.json();
    }).then(function (response) {
      var resolvedSettings = {
        authority: authority,
        authorize: response.authorization_endpoint,
        clientId: settings.clientId,
        debug: debug,
        scope: settings.scope,
        token: response.token_endpoint,
        userInfo: response.userinfo_endpoint
      };

      if (useCache) {
        settingsCache = resolvedSettings;
      }

      return resolvedSettings;
    });
  }

  (0, _debugLogger.default)('returning optimised settings with no metadata query', settings.debug);
  return Promise.resolve(settings);
};

var _default = settingsResolver;
exports.default = _default;